// 金额过滤器
let formatMoney = value => {
  if (!value && typeof value !== 'number') return '0.00'
  return '￥' + (value / 1000).toFixed(2)
}
export { formatMoney }


// WEBPACK FOOTER //
// ./src/filter/filter.js